export default __webpack_public_path__ + "static/HomePageBannerVideo-2c60fb6079cc809f3355e25dfe7d61a9.mp4";